import { useGetParentByStudentId } from '~/entities/parent';

import { AddEmergencyContact } from './add-emergency-contact';
import { EmergencyContactCard } from './emergency-contact-card';

export function EmergencyContactCards({ studentId }: { studentId: string }) {
  const { data: parent, isLoading } = useGetParentByStudentId(studentId);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (!parent) {
    return <div>Parent not found</div>;
  }

  return (
    <div className='flex flex-wrap items-stretch gap-4'>
      {parent.emergencyContacts.map((contact, index) => {
        return (
          <EmergencyContactCard
            key={`emergency-contact-${index}`}
            contact={contact}
            contactIndex={index}
            parent={parent}
            studentId={studentId}
          />
        );
      })}
      <AddEmergencyContact parent={parent} studentId={studentId} />
    </div>
  );
}
